import classNames from "classnames";
import Loader from "../../Loader/Loader";
import "./UpdateLicense.scss";
import { IUpdateLicense } from "./interface";
import { useSharedState } from "../../../../components/services/WindowSizeService";
import { useEffect, useState } from "react";
import { authorizationService } from "../../../api_services/authorizationService";
import { alertService } from "../../Services/alertService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../../Utils/Utils";
const UpdateLicense = (props: IUpdateLicense) => {
    const { onClose, onSubmit, data } = props;
    const windowSize$ = useSharedState();
    const [readyFlag, setReadyFlag] = useState<boolean>(false);
    const [licenseDetails, setLicenseDetails] = useState<any>();
    const [inputs, setInputs] = useState<any>({});
    const [submitFlag, setSubmitFlag] = useState<boolean>(false);

    let payLoad: any = getURLDataMethod();
    
    useEffect(() => {
        getLicenseDetails();
    }, [])

    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values: any) => ({ ...values, [name]: value }))
    }

    const getLicenseDetails = async () => {
        if (payLoad) {
            const payload = JSON.parse(JSON.stringify(payLoad));
            let siteID = localStorage.getItem("siteID")
            payload.site_id = siteID;
            if (payload && payload['firmware_version']) {
                const device = payload['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.getLicenseDetails("GetLicenseDetails", payload, device, payload['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                setLicenseDetails(res.body);
                                setReadyFlag(true);
                                // alertService.serviceSuccessMessage("Order details received successfully");
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            console.log("error");
                        }
                    })
                } catch (err: any) {
                    console.log(err);
                }
            }
        }
    }

    const updateLicense = async () => {
        if (payLoad) {
            const payload = JSON.parse(JSON.stringify(payLoad));
            let siteID = localStorage.getItem("siteID")
            payload.site_id = siteID;
            payload["license"] = inputs?.license;
            if (payload && payload['firmware_version']) {
                const device = payload['device_type'].split('iLens-')[1];
                try {
                    return await authorizationService.updateLicense("UpdateLicense", payload, device, payload['firmware_version']).then((res: any) => {
                        if (res.status === 200) {
                            if ((res.body.status === "success") && res.body.message) {
                                alertService.serviceSuccessMessage(res.body.message);
                                onClose && onClose(false);
                            }
                            else {
                                alertService.serviceErrorMessage(res.body.message);
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            console.log("error");
                        }
                    })
                }
                catch (err: any) {
                    console.log(err);
                }
            }
        }
    }

    const save = () => {
        setSubmitFlag(true);
        if (inputs?.license) {
            updateLicense()
        }
    }
    return (
        <div className="update-license">
            {
                readyFlag ?
                    <>
                        <div className={classNames("modal-body py-3 events-none",
                            {
                                "respon-drawer": windowSize$ === "sm" || windowSize$ === "xs",
                                "dr": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                            })} >
                            <div className="row">
                                <label className="mb-2">
                                    Add Certificate:
                                </label>
                                <textarea
                                    typeof="text"
                                    name="license"
                                    value={inputs?.license}
                                    onChange={handleChange}
                                    className="form-control text-box textbox-Update m-1"
                                    id="AddCertificate"
                                >
                                </textarea>
                                {submitFlag && !inputs?.license &&
                                    <div className="text-danger mt-2">Please Enter License</div>
                                }
                            </div >
                        </div >
                    </>
                    :
                    <Loader hasError={false} styleClass="loader-page-style w-100" />
            }
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={() => onClose && onClose(false)}>Close</button>
                    <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={save} >Save</button>
                </div>
            </div>
        </div>
    )
}
export default UpdateLicense;